import DOMPurify from 'dompurify'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate, useParams } from 'react-router-dom'
import { ArticleDetailType, BoardConfigType } from '../../@types/board'
import { getArticleDetail, getBoardConfiguration } from '../../api/board'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

export default function NoticeView() {
  const [item, setItem] = useState<ArticleDetailType>()
  const [boardCon, setBoardCon] = useState<BoardConfigType[]>([])
  const [boardNo, setBoardNo] = useState<number>(0)
  const navigate = useNavigate()
  const params = useParams()
  const { isAppView } = useAppContext()
  const { setIsLottie } = useCommonContext()

  useEffect(() => {
    getBoardConfiguration().then((res) => {
      setBoardCon(res.data.boardConfigs)
    })
  }, [])

  useEffect(() => {
    if (boardCon && Array.isArray(boardCon)) {
      const noticeBoard = boardCon.find((el: any) => el.boardId === 'notice')
      if (noticeBoard) {
        setBoardNo(noticeBoard.boardNo)
      }
    }
  }, [boardCon])

  useEffect(() => {
    if (params.id !== undefined) {
      if (boardNo) {
        getArticleDetail(boardNo, params.id)
          .then((res) => {
            setItem(res.data)
            setIsLottie(false)
          })
          .catch((err) => console.log(err))
      }
    }
  }, [boardNo])
  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>공지사항</PageTitle>
            <hr />
            <div className='notice_view'>
              <div className='title'>
                <p>{item?.title}</p>
                <span className='date'>
                  {item?.registerYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}
                </span>
              </div>
              <div className='content' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.content || '') }}>
                {/* <div className='title'>
              <p>3.11.11v 업데이트 알림</p>
              <span className='date'>2024. 03. 13</span>
            </div>
            <div className='content'>
              안녕하세요
              <br />
              낚시가 더 즐거워지는 어바웃피싱입니다!
              <br />
              <br />
              낚시하기 정말 좋은 봄날씨가 이어지고 있습니다!
              <br />
              어바웃피싱은 낚시 시즌을 맞아 5월 대규모 업데이트를 준비하고 있으며,
              그전까지 서비스 이용에 문제없도록 작은 기능들과 오류를 개선해
              3.11.16v로 업데이트를 진행했습니다.
              <br />
              <br />
              그럼 업데이트 내용을 간단하게 알아볼까요?
              <br />
              <br />
              피싱맵에서 볼 수 있는 바다 날씨 정보의 간조/만조 정보에 오류가
              있었어요!
              <br />
              시간의 순서대로 데이터가 노출되며 간조와 만조가 서로 뒤바뀌는 경우가
              발생했었고, 해당 오류를 조치해 업데이트를 진행했습니다!
              <br />
              정보제공에 오류가 없도록 조금 더 면밀하게 확인하는 어바웃피싱이
              되겠습니다!
              <br />
              <br />
              이 외에도 게시글 작성 시 필수사항에 대한 인지방안 추가와 NFC 로그인
              관련 수정 등 서비스 안정성을 위해 버그와 기능들을 개선했어요!
              <br />
              회원분들의 더 즐거운 낚시를 위해! 매일 노력하는 어바웃피싱이
              되겠습니다!
              <br />
              <br />
              앞으로도 많은 관심과 사랑 부탁드립니다.
              <br />
              <br />본 공지사항은 언제든지 마이홈 &gt; 고객센터 &gt; 공지사항
              목록에서 확인 가능합니다.
            </div> */}
              </div>
              <button
                className='btn_go_list'
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.goBack)
                  } else {
                    navigate(-1)
                  }
                }}
              >
                목록 보기
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
